import { render, staticRenderFns } from "./StembleVideo.vue?vue&type=template&id=e4976f4a&scoped=true&"
import script from "./StembleVideo.vue?vue&type=script&lang=js&"
export * from "./StembleVideo.vue?vue&type=script&lang=js&"
import style0 from "./StembleVideo.vue?vue&type=style&index=0&id=e4976f4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4976f4a",
  null
  
)

export default component.exports